import React, { useState } from 'react';

import IconFavorite from '@mui/icons-material/FavoriteOutlined';
import IconSave from '@mui/icons-material/GetApp';
import { Button, IconButton, Tooltip } from '@mui/material';

interface Props {
    iconButton?: boolean;
    value: string;
}

const DownloadButton: React.FC<Props> = ({ iconButton, value, ...restProps }) => {
    const [downloaded, setDownloaded] = useState(false);

    const handleSave = () => {
        setDownloaded(true);
        setTimeout(() => setDownloaded(false), 3000);
    };

    const saveFile = () => {
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(value));
        element.setAttribute('download', 'exploit.txt');

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);

        handleSave();
    };

    if (iconButton) {
        return (
            <Tooltip title={'Download'}>
                <IconButton size="small" {...restProps} onClick={saveFile}>
                    {downloaded ? <IconFavorite /> : <IconSave />}
                </IconButton>
            </Tooltip>
        );
    }

    return (
        <Button onClick={saveFile} startIcon={downloaded ? <IconFavorite /> : <IconSave />} color="secondary">
            {'Download'}
        </Button>
    );
};

export default DownloadButton;
